var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-body m-2" },
    [
      _c("vue-apex-charts", {
        attrs: {
          options: _vm.chartOptions,
          series: _vm.series,
          width: "100%",
          height: "500",
          type: "line"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card text-center border-secondary mb-3" }, [
            _c("div", { staticClass: "card-header text-default" }, [
              _vm._v("\n                    Delivered to\n                ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body text-default" }, [
              _c("h5", { staticClass: "card-title text-default" }, [
                _vm._v(_vm._s(_vm.reportSummary.total))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card text-center border-primary mb-3" }, [
            _c("div", { staticClass: "card-header" }, [
              _vm._v("\n                    Opens\n                ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body text-primary" }, [
              _c("h5", { staticClass: "card-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.percentage(
                      _vm.reportSummary.open,
                      _vm.reportSummary.total
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(_vm._s(_vm.reportSummary.open))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card text-center border-success mb-3" }, [
            _c("div", { staticClass: "card-header" }, [
              _vm._v("\n                    Unique Opens\n                ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body text-success" }, [
              _c("h5", { staticClass: "card-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.percentage(
                      _vm.reportSummary.unique_open,
                      _vm.reportSummary.total
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(_vm._s(_vm.reportSummary.unique_open))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card text-center border-warning mb-3" }, [
            _c("div", { staticClass: "card-header" }, [
              _vm._v("\n                    Clicks\n                ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body text-warning" }, [
              _c("h5", { staticClass: "card-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.percentage(
                      _vm.reportSummary.click,
                      _vm.reportSummary.total
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(_vm._s(_vm.reportSummary.click))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card text-center border-danger mb-3" }, [
            _c("div", { staticClass: "card-header" }, [
              _vm._v("\n                    Unique Clicks\n                ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body text-danger" }, [
              _c("h5", { staticClass: "card-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.percentage(
                      _vm.reportSummary.unique_click,
                      _vm.reportSummary.total
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(_vm._s(_vm.reportSummary.unique_click))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card text-center border-secondary mb-3" }, [
            _c("div", { staticClass: "card-header text-default" }, [
              _vm._v("\n                    Bounce\n                ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body text-default" }, [
              _c("h5", { staticClass: "card-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.percentage(
                      _vm.reportSummary.bounce,
                      _vm.reportSummary.total
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "card-text" }, [
                _vm._v(_vm._s(_vm.reportSummary.bounce))
              ])
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9343244a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9343244a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/cms/js/components/report/CampaignReportComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-9343244a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/cms/js/components/report/CampaignReportComponent.vue
// module chunks = 0